<template>
	<div class="watch-readings-details-widget widget-history" :class="cssClass">
		<div class="header">
			<h2>{{ title }}</h2>
		</div>
		<div class="body">
			<h1>{{ readingType }}</h1>
			<input-date-picker v-model="dateInput" @input="onInput"/>
			<div class="history-chart-wrapper">
				<geofencing-history-map v-if="isGeofencing && !loading && isReady"
					:user_uid="user_uid"
					:watch_id="watch_id"
					:readings="readings.data"
					:intervalStart="interval.start"
					:intervalEnd="interval.end"/>
				<biometric-history-chart v-if="isBiometric && !loading && isReady"
					:type="type_id"
					:readings="readings.data"
					:intervalStart="interval.start"
					:intervalEnd="interval.end"
					:highlight="readingHighlight"/>
				<spinner v-if="loading" class="spinner"/>
			</div>
		</div>
		<button @click="refresh" class="btn btn-icon btn-refresh mobile">&nbsp;</button>
	</div>
</template>

<script>
import uniqueid from '@/utils/uniqueid'
import Readings from '@/utils/readings'
import Reading from '@/classes/Reading'
import BiometricHistoryChart from '../../biometric/widgets/history/BiometricWidgetHistoryChart'
import GeofencingHistoryMap from '../../geofencing/widgets/history/GeofencingWidgetHistoryMap'
export default {
	components: {
		BiometricHistoryChart,
		GeofencingHistoryMap
	},
	props: [
		'user_uid',
		'watch_id',
		'type_id',
		'refresh'
	],
	data () {
		return {
			name: 'watch biometric history',
			isReady: false,
			readings: {
				data: []
			},
			interval: {
				start: null,
				end: null
			},
			loadingSet: new Set(),
			loadingTracker: 1,
			dateInput: this.$moment().format('YYYY-MM-DD'),
			readingHighlight: null,
			routes: [
				'WatchBiometricView',
				'WatchGeofencing'
			]
		}
	},
	computed: {
		isGeofencing () {
			return this.type_id === Readings.TYPE_GEOFENCING
		},
		isBiometric () {
			return this.type_id !== Readings.TYPE_GEOFENCING
		},
		readingType () {
			return this.type_id ? Readings.readingTypes.get(parseInt(this.type_id)).name : ''
		},
		cssClass () {
			return this.type_id ? Readings.readingTypes.get(parseInt(this.type_id)).cssClass : ''
		},
		selectedDate () {
			return this.interval.start ? this.$moment(this.interval.start).format('YYYY-MM-DD') : ''
		},
		loading () {
			let temp = this.loadingTracker // Hack, force Vue computing loading
			return this.loadingSet.size > 0
		},
		title () {
			return this.isGeofencing ? this.$t('readings.general.history_map') : this.$t('readings.general.history_graph')
		}
	},
	/*watch: {
		'$route' (to, from) {
			if ((from.name === to.name) || (this.routes.includes(from.name) && this.routes.includes(to.name))) {
				this.isReady = false
				this.readings.data = []
			}
		}
	},*/
	methods: {
		getReadings () {
			const uid = uniqueid()
			this.loadingSet.add(uid)
			this.loadingTracker++ // Hack, force Vue computing loading
			this.readings.data = []
			this.$api.readings.getAllByTypeBetweenDates(this, this.user_uid, this.watch_id, this.type_id, this.interval.start, this.interval.end)
				.then(response => {
					this.$log.info(this.name, 'readings.getAllByTypeBetweenDates OK', response)()
					const readings = []
					response.body.forEach(element => {
						readings.push(new Reading(element))
					})
					this.readings.data = readings.sort((a, b) => {
						if (this.$moment(a.datetime) < this.$moment(b.datetime)) return -1
						if (this.$moment(a.datetime) > this.$moment(b.datetime)) return 1
						return 0
					})
				}).catch(error => {
					this.$log.error(this.name, 'readings.getAllByTypeBetweenDates ERROR', error)()
				}).finally(() => {
					this.loadingSet.delete(uid)
					this.loadingTracker++ // Hack, force Vue computing loading
					this.isReady = true
				})
		},
		resetInterval () {
			const moment = this.$moment().hour(0).minutes(0).seconds(0)
			this.dateInput = moment.format('YYYY-MM-DD')
			this.interval.start = moment.format()
			this.interval.end = this.$moment(this.interval.start).add(1, 'd').format()
		},
		onInput () {
			const date = this.$moment(this.dateInput, 'YYYY-MM-DD')
			if (date.isValid()) {
				this.interval.start = date.format()
				this.interval.end = date.add(1, 'd').format()
				this.getReadings()
			}
		},
		onRouteChanged () {
			// Next tick, otherwise type_id is not correct
			this.$nextTick(function () {
				this.$emit('biometric-details-widget-history-reset-readings')
				this.resetInterval()
				this.getReadings()
			})
		},
		onHighlightReading (reading) {
			const date = this.$moment(reading.datetime, 'YYYY-MM-DD')
			if (date.isValid()) {
				this.dateInput = date.format('YYYY-MM-DD')
				this.readingHighlight = reading
			}
		}
	},
	created () {
		this.$parent.$on('biometric-details-route-changed', this.onRouteChanged)
		this.$parent.$on('biometric-details-refresh-readings', this.onRouteChanged)
		this.$root.$on('biometric-details-highlight-latest-reading', this.onHighlightReading)
	},
	mounted () {
		this.resetInterval()
		this.getReadings()
	},
	beforeDestroy () {
		this.$parent.$off('biometric-details-route-changed', this.onRouteChanged)
		this.$parent.$off('biometric-details-refresh-readings', this.onRouteChanged)
		this.$root.$off('biometric-details-highlight-latest-reading', this.onHighlightReading)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/ReadingsWidgetHistory.vue